import Vue from 'vue'
const mutations = {

  /**
   * @param state
   * @param user
   * @constructor
   */
  REMOVE_FROM_FILELIST (state, file) {
    let oldfileindex = state.file_list.findIndex(oldfile => oldfile.filename === file.filename)
    if (oldfileindex === -1) return
    state.file_list.splice(oldfileindex, 1)
  },
  SET_FILELIST (state, files) {
    Vue.set(state, 'file_list', files)
  },
  UPDATE_FILELIST (state, file) {
    if (state.file_list.length === 0) {
      console.log('pushing to filelist')
      return state.file_list.push(file)
    }
    let oldfileindex = state.file_list.findIndex(oldfile => oldfile.id === file.id)
    if (oldfileindex === -1) return state.file_list.push(file)
    state.file_list.splice(oldfileindex, 1, file)
  },
  SET_FILES_UPLOADING (state, files) {
    Vue.set(state, 'files_uploading', files)
  },
  ADD_SELECTED_LEFT (state, files) {
    Vue.set(state, 'files_selected_left', files)
  },
  ADD_SELECTED_RIGHT (state, files) {
    Vue.set(state, 'files_selected_right', files)
  },
  SET_FILES_WHERE_CHANGED_BY_WS (state, value) {
    Vue.set(state, 'files_where_changed_by_ws', value)
  }
}

export default mutations



//////////////////
// WEBPACK FOOTER
// ./state/file/file.mutations.js
// module id = null
// module chunks = 